import React, { useEffect, useState, useRef } from "react";
import { View, ScrollView, Text, ImageBackground, SafeAreaView, TouchableOpacity, Image, Linking, ActivityIndicator, Dimensions } from "react-native";
import { useNavigation } from "@react-navigation/native";
import MobileHeader from "../components/mHeader";
import Footer from "../components/footer";
import Header from "../components/header";
import i18n from "../components/i18n";
import CookieConsent from "../components/CookieConsent";
import NewMobileHeader from "../components/newMobileHeader";
import AsyncStorage from "../components/AsyncStorage";
import axios from "axios";
import { API_MIDDLEWARE, API_REGION } from "@env";
import { region } from "expo-localization";
import loyalty from "../api/loyalty";

const Promotions = () => {
    const navigation = useNavigation();
    const [lang, setLang] = useState("en");
    const [isLoading, setIsLoading] = useState(false);
    const [expiryOverlay, setExpiryOverlay] = useState(false)
    const [memberCode, setMemberCode] = useState("");
    const [memberRegion, setMemberRegion] = useState("");
    const [member, setMember] = useState({})
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [cartTot, setCartTot] = useState("0")
    const [bubble, setBubble] = useState(false)
    const [isExpired, setIsExpired] = useState(false)

    const mounted = useRef(false);

    const windowWidth = Dimensions.get("window").width;

    useEffect(() => {
        mounted.current = true;

        AsyncStorage.getData("mCode").then((value) => {
            if (!value) {
                //navigation.push("Login");
            } else {
                setIsLoggedIn(true)
                let loginDetail = JSON.parse(value);
                console.log(loginDetail)
                setMemberCode(loginDetail.code);
                setMemberRegion(loginDetail.region);

                let data = {
                    code: loginDetail.code,
                    username: loginDetail.username,
                    region: loginDetail.region,
                };

                customerGet(data, (customer) => {
                    setMember(customer)

                    if (customer.memberstatus == "EXPIRED") {
                        setIsExpired(true)
                    }
                })

                AsyncStorage.getData("shoppingcart").then((coupons) => {
                    if (coupons) {
                        let couponItems = JSON.parse(coupons)
                        calTotal(couponItems)
                    }
                })
            }
        })

        AsyncStorage.getData("lang").then((lang) => {
            if (lang) {
                setLang(lang)
            }
        });

        return () => {
            mounted.current = false;
        };
    }, []);

    const addToCard = (type) => {
        if (isExpired) {
            setExpiryOverlay(true)
            return
        }

        var cart = {}
        AsyncStorage.getData("shoppingcart").then((value) => {
            if (!value) {
                cart = {
                    "100": 0,
                    "500": 0,
                    "1000": 0
                }
            } else {
                cart = JSON.parse(value)
            }

            cart[type] = cart[type] + 1

            console.log(cart)
            calTotal(cart)
            AsyncStorage.storeData("shoppingcart", JSON.stringify(cart))

            showBubble()
        })
    }

    const buyNow = (type) => {
        if (isExpired) {
            setExpiryOverlay(true)
            return
        }

        var cart = {}
        AsyncStorage.getData("shoppingcart").then((value) => {
            if (!value) {
                cart = {
                    "100": 0,
                    "500": 0,
                    "1000": 0
                }
            } else {
                cart = JSON.parse(value)
            }

            cart[type] = cart[type] + 1

            console.log(cart)
            AsyncStorage.storeData("shoppingcart", JSON.stringify(cart))

            navigation.push("ShoppingCart")
        })
    }

    const calTotal = (items) => {
        let total = items["100"] + items["500"] + items["1000"]

        setCartTot(total.toString())
    }

    const customerGet = (data, callback) => {
        console.log("customer get")
        
        let formdata = {
            method: "getCust",
            //username: data.username,
            code: data.code,
            region: data.region
        }

        loyalty.api(formdata).then((res) => {
            callback(res)
        })
    };

    const showBubble = () => {
        setBubble(true)

        setTimeout(() => {
            setBubble(false)
        }, 3000)
    }

    return (
        <View className="flex-1 md:bg-[#efefef] w-full" pointerEvents={!isLoading ? "auto" : "none"}>
            <ImageBackground source={require("../assets/login-bg.png")} resizeMode="cover" className="flex-1 justify-start items-center w-full h-full">
                {isLoading && (
                    <View
                        className="left-0 right-0 top-0 bottom-0 justify-center items-center bg-[#f3f3f394] z-10 w-full h-full"
                        style={{ position: "fixed" }}
                        pointerEvents={"none"}
                    >
                        <ActivityIndicator size="large" color={"#BD9B60"} />
                    </View>
                )}
                <SafeAreaView className="flex-1 bg-white flex justify-start items-center w-full md:bg-transparent">
                    <NewMobileHeader cartTotal={cartTot} />
                    {/* <MobileHeader title={i18n.t("mobileApp.title")} /> */}
                    <ScrollView className="w-full flex-1">
                        <Header cartTotal={cartTot} />
                        <View className="items-center content-start">
                            <View className="w-11/12 md:w-4/5 md:max-w-screen-xl md:h-auto md:m-auto md:bg-white md:p-7 mt-6 md:mb-24 pb-16 md:px-20">

                                {
                                    !isLoggedIn &&
                                    <>
                                        <Text className="text-black text-2xl mt-6 mb-2 uppercase font-Crimson text-center">{i18n.t("promotions.header")}</Text>
                                        <View className="w-full h-[0.5px] bg-brandgold mt-3"></View>
                                    </>
                                }
                                {
                                    isLoggedIn &&
                                    <Text className="text-brandgold text-lg mb-2 uppercase font-Crimson text-center">{i18n.t("promotions.welcome")}, {member.title} {member.last_name}!</Text>
                                }
                                <Text className="text-brandgold text-2xl mt-6 font-Crimson text-center">{i18n.t("promotions.intro1")}</Text>
                                <Text className="text-black text-lg mt-0 mb-2 font-Crimson text-center">{i18n.t("promotions.intro2")}</Text>

                                <View className="w-full flex flex-col md:flex-row justify-between">
                                    <View className="w-full md:w-1/3 py-4 md:pr-8">
                                        {/* <View className="w-full h-44 bg-gray-200 rounded-2xl"></View> */}
                                        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                            <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-500.png")} resizeMode="contain" />
                                        </View>
                                        <View>
                                            <Text className="text-base text-black text-center mt-2">HKD500{"\n"}{i18n.t("promotions.evoucher")}</Text>
                                            <Text className="text-base text-brandgold text-center mt-2">HKD475 ({i18n.t("promotions.save")} 5%) </Text>
                                        </View>
                                        {
                                            isLoggedIn &&
                                            <View>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { addToCard("100") }}>
                                                    <Text className="text-white w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.add_to_cart")}</Text>
                                                </TouchableOpacity>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-white border border-brandgold mt-4 mb-2" onPress={() => { buyNow("100") }}>
                                                    <Text className="text-brandgold w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.buy_now")}</Text>
                                                </TouchableOpacity>
                                            </View>
                                        }
                                    </View>
                                    <View className="w-full md:w-1/3 py-4 md:px-4">
                                        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                            <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-1000.png")} resizeMode="contain" />
                                        </View>
                                        <View>
                                            <Text className="text-base text-black text-center mt-2">HKD1,000{"\n"}{i18n.t("promotions.evoucher")}</Text>
                                            <Text className="text-base text-brandgold text-center mt-2">HKD900 ({i18n.t("promotions.save")} 10%) </Text>
                                        </View>
                                        {
                                            isLoggedIn &&
                                            <View>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { addToCard("500") }}>
                                                    <Text className="text-white w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.add_to_cart")}</Text>
                                                </TouchableOpacity>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-white border border-brandgold mt-4 mb-2" onPress={() => { buyNow("500") }}>
                                                    <Text className="text-brandgold w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.buy_now")}</Text>
                                                </TouchableOpacity>
                                            </View>
                                        }
                                    </View>
                                    <View className="w-full md:w-1/3 py-4 md:pl-8">
                                        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                            <Image style={{ width: "100%", aspectRatio: 1 }} source={require("../assets/promotions/hkd-5000.png")} resizeMode="contain" />
                                        </View>
                                        <View>
                                            <Text className="text-base text-black text-center mt-2">HKD5,000{"\n"}{i18n.t("promotions.evoucher")}</Text>
                                            <Text className="text-base text-brandgold text-center mt-2">HKD4,400 ({i18n.t("promotions.save")} 12%) </Text>
                                        </View>
                                        {
                                            isLoggedIn &&
                                            <View>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-brandgold mt-4" onPress={() => { addToCard("1000") }}>
                                                    <Text className="text-white w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.add_to_cart")}</Text>
                                                </TouchableOpacity>
                                                <TouchableOpacity className="w-full h-10 max-h-10 bg-white border border-brandgold mt-4 mb-2" onPress={() => { buyNow("1000") }}>
                                                    <Text className="text-brandgold w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.buy_now")}</Text>
                                                </TouchableOpacity>
                                            </View>
                                        }
                                    </View>
                                </View>

                                <Text className="text-black text-sm mt-6 mb-1.5 uppercase font-Crimson">{i18n.t("promotions.tnc")}</Text>

                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">1.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_1")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">2.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_2")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">3.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_3")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">4.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_4")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">5.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_5")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">6.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_6")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">7.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_7")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">8.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_8")}
                                    </Text>
                                </View>
                                <View className="mb-2 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">9.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_9")}
                                    </Text>
                                </View>
                                <View className="mb-10 flex-row">
                                    <Text className="text-sm text-[#84818A] font-Crimson">10.</Text>
                                    <Text className="flex-1 pl-2 text-sm text-[#84818A] font-Crimson">
                                        {i18n.t("promotions.tnc_10")}
                                    </Text>
                                </View>

                                {
                                    !isLoggedIn &&
                                    <TouchableOpacity
                                        className="w-full h-10 max-h-10 bg-brandgold mt-4 md:w-[300px] md:m-auto md:block md:text-center"
                                        onPress={() => navigation.push("Login")}
                                    >
                                        <Text className="text-white w-full h-10 leading-10 text-center font-normal uppercase">{i18n.t("promotions.login_purchase")}</Text>
                                    </TouchableOpacity>
                                }
                            </View>
                        </View>



                        <Footer />
                        <CookieConsent />
                    </ScrollView>
                </SafeAreaView>
            </ImageBackground>

            <View className={"top-[15%] right-[5%] md:top-12 md:right-12 duration-500 ease-in transition-opacity " + (bubble ? "opacity-100" : "opacity-0")} style={{ position: "fixed", transitionProperty: 'opacity', transitionDuration: '0.5s', transitionTimingFunction: 'ease-in' }}>
                <View className="bg-white px-6 py-3 relative shadow-sm rounded-sm">
                    <Text className="text-sm text-[#28a745] font-bold font-NunitoSans text-center">
                        {i18n.t("promotions.added_to_cart")}
                    </Text>
                </View>
            </View>

            {
                expiryOverlay &&

                <View className="top-0 right-0 bottom-0 left-0 justify-center items-center bg-[#00000075]" style={{ position: "fixed" }}>
                    <View className="w-11/12 max-w-md bg-white px-6 py-3 relative">
                        <TouchableOpacity
                            className="absolute right-1 top-1"
                            onPress={() => {
                                setExpiryOverlay(false)
                            }}
                        >
                            <Image className="w-5 h-5" source={require("../assets/btn-close.png")} />
                        </TouchableOpacity>

                        <Text className="text-xl font-semibold text-brandgold text-center pt-11 pb-4 uppercase font-Crimson">
                            {i18n.t("promotions.member_expiry")}
                        </Text>

                        <Text className="text-base text-black text-center py-2">{i18n.t("promotions.renew_member")}</Text>

                        <View className="text-right flex items-end mb-8">
                            <TouchableOpacity
                                className="w-full h-8 max-h-8 bg-brandgold mt-4 mr-0"
                                onPress={() => { navigation.push('Profile') }}
                            >
                                <Text className="text-white w-full h-8 leading-8 text-center font-normal font-PingFangSC uppercase">{i18n.t("promotions.renew_now")}</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            }
        </View>
    );
};

export default Promotions;
